import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Container, Box } from 'theme-ui'

import media from '../../../common/MediaQueries'
import { WithTheme } from '../../../setup/index'
import { HeroContainerStyledProps } from '../Hero/types'

const HeroStyled = styled.div``

const HeroBackgroundStyled = styled.div`
  position: absolute;
  top: -1rem;
  width: 26.25rem;

  ${({ theme }) =>
    theme.direction === 'rtl'
      ? css`
          transform: scale(1, -1) rotate(180deg);
        `
      : css`
          transform: none;
        `}

  svg {
    width: 100%;
    height: 100%;
    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: -21.625rem;
          `
        : css`
            left: -21.625rem;
          `}
  }

  @media ${media.phone} {
    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `}
  }

  @media ${media.tablet} {
    width: 60%;
  }

  @media ${media.desktop} {
    width: 55%;
  }
`

const HeroBlockStyled = styled(Container)<WithTheme>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column-reverse;

  @media ${media.tablet} {
    flex-direction: row;
    align-items: flex-start;
  }
`

const HeroContentStyled = styled.div`
  position: relative;
  z-index: 1;

  @media ${media.maxTablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-left: 1.75rem;' : 'padding-right: 1.75rem;')}
    margin-bottom: 0;
    width: 46%;
    margin-left: auto;
  }
  @media ${media.desktop} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-left: 4.875rem;' : 'padding-right: 4.875rem;')}
  }
`

const HeroTitleStyled = styled.div`
  font-size: 1.5625rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.green};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin-bottom: 1.875rem;

  @media ${media.phone} {
    font-size: 1.875rem;
  }
`

const HeroSubtitleStyled = styled.div`
  font-size: 1.0625rem;
  font-weight: 500;
  text-align: center;
  margin-bottom: 3.125rem;
  max-width: 25rem;
  @media ${media.phone} {
    margin: 0 auto 4.375rem;
  }
`

const HeroFormStyled = styled.div``

const HeroMediaStyled = styled.div`
  margin-top: 70px;

  @media ${media.phone} {
    width: 54%;
    display: flex;
  }

  @media ${media.tablet} {
    margin-top: 0;
  }
`

const HeroContainerStyled = styled(Box)<WithTheme<HeroContainerStyledProps>>`
  position: relative;
  overflow: hidden;
  padding: 6.125rem 0 3.375rem;

  .gatsby-image-wrapper img {
    width: auto;
    height: auto;
    max-width: 100%;
  }

  @media ${media.phone} {
    padding: 6.875rem 0 9.375rem;
  }
`

export {
  HeroContainerStyled,
  HeroStyled,
  HeroBackgroundStyled,
  HeroContentStyled,
  HeroTitleStyled,
  HeroSubtitleStyled,
  HeroMediaStyled,
  HeroBlockStyled,
  HeroFormStyled
}
